import React from 'react';
import { CardActions } from 'material-ui/Card';
import GenerateButton from '../LevyButton';
import { List, Edit, Create, Show, SimpleShowLayout, ShowButton,
    RefreshButton, CreateButton,
    Datagrid, TextField, NumberField, BooleanField, DateField, ReferenceField, FunctionField,
    EditButton, SimpleForm, TextInput, ReferenceInput, BooleanInput, DateInput, NumberInput, SelectInput } from 'admin-on-rest';

export const ContractShow = (props) => (
    <Show {...props}>
        <SimpleShowLayout>
            <ReferenceField label="Client" source="client.id" reference="client" linkType="show">
                <TextField source="companyName" />
            </ReferenceField>
            <BooleanField source="isActive" label="Actif" />
            <TextField source="reason" label="Objet" />
            <NumberField source="amount" label="Montant" />
            <BooleanField source="isMonthly" label="Mensuel" />
            <DateField source="startDate" label="Date de début" />
            <NumberField source="dayOfMonth" label="Jour de prélèvement" />
            <DateField source="endDate" label="Date de fin" />
            <DateField source="effectiveDate" label="Date d'effet" />
        </SimpleShowLayout>
    </Show>
);     

const cardActionStyle = {
    zIndex: 2,
    display: 'inline-block',
    float: 'right',
};

const ContractListActions = ({ basePath, data }) => (
    <CardActions style={cardActionStyle}>
        <GenerateButton record={data}/>
        <CreateButton basePath={basePath} />
        <RefreshButton />
    </CardActions>
);   



export const ContractList = (props) => (
    <List actions={<ContractListActions />} title="Tous les contrats" {...props}>
        <Datagrid>
            <BooleanField source="isActive" label="Actif" />
            <ReferenceField label="Client" source="client.id" reference="client" linkType="show">
                <TextField source="companyName" />
            </ReferenceField>
            <TextField source="reason" label="Objet" />
            <NumberField source="amount" label="Montant HT" />
            <FunctionField label="Montant TTC" render={record => `${Number((record.amount * 1.2).toFixed(2))}`} />
            <BooleanField source="isMonthly" label="Mensuel" />
            <DateField source="startDate" label="Date de début" />
            <NumberField source="dayOfMonth" label="Jour de prélèvement" />
            <DateField source="effectiveDate" label="Date d'effet" />
            <ShowButton />
            <EditButton />
        </Datagrid>
    </List>
);

export const ContractEdit = (props) => (
    <Edit {...props}>
        <SimpleForm>
            <TextInput source="reason" label="Objet" />
            <BooleanInput source="isActive" label="Actif" />
            <NumberInput source="amount" label="Montant" />
            <BooleanInput source="isMonthly" label="Mensuel" />
            <DateInput source="startDate" label="Date de début" />
            <NumberInput source="dayOfMonth" label="Jour de prélèvement" />
            <DateInput source="endDate" label="Date de fin" />
            <DateInput source="effectiveDate" label="Date d'effet" />
        </SimpleForm>
    </Edit>
);

export const ContractCreate = (props) => (
    <Create {...props}>
        <SimpleForm>
        <ReferenceInput label="Client" source="client" reference="client" allowEmpty>
                <SelectInput optionText="companyName" />
            </ReferenceInput>
            <BooleanInput source="isActive" label="Actif" />
            <TextInput source="reason" label="Objet" />
            <NumberInput source="amount" label="Montant Hors Taxes"/>
            <BooleanInput source="isMonthly" label="Mensuel" />
            <DateInput source="startDate" label="Date de début" />
            <NumberInput source="dayOfMonth" label="Jour de prélèvement" />
            <DateInput source="endDate" label="Date de fin" />
            <DateInput source="effectiveDate" label="Date d'effet" />
        </SimpleForm>
    </Create>
);


// WEBPACK FOOTER //
// src/resources/contracts.js